import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import NoteForm from './NoteForm';
import { getNote, editNote } from './ducks/noteActions';

class EditNote extends React.Component {
  componentDidMount() {
    this.props.getNote(this.props.match.params.id, this.props.history);
  }

  onSubmit = text => {
    this.props.editNote({
      id: this.props.note.id,
      text: text
    });
  };

  render() {
    if (this.props.noteIsUpdated) {
      return (
        <Redirect
          to={`/clients/${this.props.match.params.client_id}?tab=notes`}
        />
      );
    }

    let titleParams = {
      pageTitle: 'Edit Note',
      linkText: 'Cancel',
      buttonText: 'Save',
      cancelLink: `/clients/${this.props.match.params.client_id}/notes/${this.props.match.params.id}`
    };

    return (
      <NoteForm
        initialTextValues={this.props.note.text}
        submitForm={this.onSubmit}
        clientId={this.props.match.params.client_id}
        titleParams={titleParams}
        history={this.props.history}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    note: state.notesReducer.note,
    noteIsUpdated: state.notesReducer.noteIsUpdated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNote: (id, history) => dispatch(getNote(id, history)),
    editNote: note => dispatch(editNote(note))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNote);
